import { AsyncPipe, NgForOf } from "@angular/common";
import { Component, inject } from "@angular/core";
import { ToasterService } from "../../../services/toaster.service";
import { ToasterItemComponent } from "./toaster-item/toaster-item.component";

@Component({
  selector: "app-toaster",
  imports: [NgForOf, ToasterItemComponent, AsyncPipe],
  templateUrl: "./toaster.component.html",
  styleUrl: "./toaster.component.scss"
})
export class ToasterComponent {
  toasterService = inject(ToasterService);
}
